export default {
  namespaced: true,
  state: {
    variantModal: false,
    activeLocationProductVariantObj: {},
    activeLocationProductVariantList: [],
    activeLocationProductVariantExistingList: []

  },
  getters: {
    variantModal: state => state.variantModal,
    activeLocationProductVariantObj: state => state.activeLocationProductVariantObj,
    activeLocationProductVariantList: state => state.activeLocationProductVariantList,
    activeLocationProductVariantExistingList: state => state.activeLocationProductVariantExistingList

  },
  mutations: {
    mutateVariantModal(state, data) {
      state.variantModal = data
    },
    mutateActiveLocationProductVariantObj(state, data) {
      state.activeLocationProductVariantObj = data
    },
    mutateActiveLocationProductVariantList(state, data) {
      state.activeLocationProductVariantList = data
    },
    mutateActiveLocationProductVariantExistingList(state, data) {
      state.activeLocationProductVariantExistingList = data
    },
    clearLocationProductVariantsState(state) {
      Object.assign(state, require('./reset/locationProductVariants.json'))
    }

  },
  actions: {
    setVariantModal(context, data) {
      context.commit('mutateVariantModal', data)
    },
    setActiveLocationProductVariantObj(context, data) {
      context.commit('mutateActiveLocationProductVariantObj', data)
    },
    setActiveLocationProductVariantList(context, data) {
      context.commit('mutateActiveLocationProductVariantList', data)
    },
    setActiveLocationProductVariantExistingList(context, data) {
      context.commit('mutateActiveLocationProductVariantExistingList', data)
    }

  }
}
